import type { Edge, Node, Viewport } from '@xyflow/react'
import type { Editor } from 'slate'
import { Transforms } from 'slate'
import type { CustomEditor } from '../../custom-types'
import { DEFAULT_FLOW_HEIGHT } from './constants'

export function withFlow<T extends CustomEditor>(editor: T) {
  const { isInline, isVoid } = editor

  editor.isInline = (element) => {
    return element.type === 'flow' ? false : isInline(element)
  }

  editor.isVoid = (element) => {
    return element.type === 'flow' ? true : isVoid(element)
  }

  return editor
}

export type FlowElement = {
  type: 'flow'
  nodes: Node[]
  edges: Edge[]
  viewport?: Viewport
  height?: number
  children: { text: '' }[]
}

export function insertFlowElement(editor: Editor) {
  const flowElement: FlowElement = {
    type: 'flow',
    nodes: [],
    edges: [],
    viewport: {
      x: 0,
      y: 0,
      zoom: 1,
    },
    children: [{ text: '' }],
    height: DEFAULT_FLOW_HEIGHT,
  }

  Transforms.insertNodes(editor, flowElement)
}
